function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2L14 4V14H2V4L4 2H12ZM2.91267 4.91267V13.0873H13.0873V4.91267H10.0527C9.702 5.698 8.914 6.246 8 6.246C7.08667 6.246 6.298 5.698 5.948 4.91267H2.91267ZM4.37867 2.91267H11.622L12.7087 4H9.33333C9.33333 4.73667 8.73667 5.33333 8 5.33333C7.264 5.33333 6.66667 4.73667 6.66667 4H3.29133L4.37867 2.91267ZM8.50007 9.0399L9.29273 9.83323C9.48807 10.0286 9.80473 10.0286 10.0001 9.83323C10.1954 9.6379 10.1954 9.32123 10.0001 9.1259L8.35407 7.4799C8.15873 7.28457 7.84207 7.28457 7.64673 7.4799L6.00007 9.1259C5.80473 9.32123 5.80473 9.6379 6.00007 9.83323C6.1954 10.0286 6.51207 10.0286 6.7074 9.83323L7.50007 9.04057V11.6465C7.50007 11.9225 7.72407 12.1465 8.00007 12.1465C8.27607 12.1465 8.50007 11.9225 8.50007 11.6465V9.0399Z",
  fill: "currentColor"
});

function SvgIconRestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRestore);
export default __webpack_public_path__ + "static/media/iconRestore.746fe389.svg";
export { ForwardRef as ReactComponent };